export const locale = {
  lang: 'vn',
  data: {
    ERROR: {
      HTTP: {
        500: {
          'TITLE': 'Internal Server Error',
          'MESSAGE': 'Internal Server ERROR'
        },
      },
    },
  },
};
